module.exports = __webpack_public_path__ + "static/media/PG-Character-Sun-Star.eeb9810f.png";